import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { TableProps } from "@/pages/it/updates-control/list/components/edit/types";

export const SelectResult: React.FC<TableProps> = ({ data }) => {
  if (!data || !data.result || data.result.length === 0) {
    return (
      <p className="text-xs p-3 border border-black/20 rounded-md my-2">
        Nenhum dado disponível ou alterado.
      </p>
    );
  }

  const rows = data.result;
  const columnNames = Object.keys(rows[0] || {});

  return (
    <div className="w-full max-w-[985px] overflow-auto max-h-[260px] border-black/20 border rounded-md">
      <Table className="w-full overflow-x-auto">
        <TableHeader>
          <TableRow>
            {columnNames.map((columnName, index) => (
              <TableHead key={index}>{columnName}</TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows?.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {columnNames.map((columnName, colIndex) => (
                <TableCell key={`${rowIndex}-${colIndex}`}>
                  {row[columnName] !== undefined ? row[columnName] : "-"}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
